import React from "react";
import { Home } from "lucide-react";

const Placeholder = ({ section }) => {
  const Icon = section?.icon || Home;
  
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <Icon className="w-16 h-16 mx-auto mb-4 text-gray-600" />
        <h2 className="text-2xl font-semibold mb-2">{section?.name}</h2>
        <p className="text-gray-400">Esta seção está em desenvolvimento</p>
      </div>
    </div>
  );
};

export default Placeholder;